import { render, staticRenderFns } from "./SuggestedTeamTypes.vue?vue&type=template&id=2fa8f4fe&scoped=true&"
import script from "./SuggestedTeamTypes.vue?vue&type=script&lang=js&"
export * from "./SuggestedTeamTypes.vue?vue&type=script&lang=js&"
import style0 from "./SuggestedTeamTypes.vue?vue&type=style&index=0&id=2fa8f4fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa8f4fe",
  null
  
)

export default component.exports